import { render, staticRenderFns } from "./DuplicateTab.vue?vue&type=template&id=3d612700&"
import script from "./DuplicateTab.vue?vue&type=script&lang=js&"
export * from "./DuplicateTab.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateTab.vue?vue&type=style&index=0&id=3d612700&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports